import { Dialog, Stack, DialogTitle, DialogActions } from "@mui/material";
import clsx from "clsx";
import { LoadingButton } from "@mui/lab";
interface DialogProps {
	open: boolean;
	modalTitle: string;
	zIndex?: number;
	buttonsSettings: {
		title: string;
		bgColor: string;
		boxShadowHover?: string;
		disabled?: boolean;
		loading?: boolean;
		action: () => void;
	}[];
}

const ActionButtonDialog = (props: DialogProps) => {
	const { open, modalTitle, zIndex, buttonsSettings } = props;
	return (
		<Dialog
			open={open}
			className="general-dialog"
			sx={{
				zIndex: zIndex ?? 1001,
			}}
		>
			<Stack
				sx={{
					padding: "24px",
					width: "292px",
				}}
			>
				<DialogTitle
					sx={{
						padding: 0,
						fontFamily: "PTSansProNarrow",
						color: "var(--text-color)",
						lineHeight: "normal",
						fontSize: "14px",
						fontWeight: 400,
					}}
				>
					{modalTitle}
				</DialogTitle>
				<DialogActions
					sx={{
						marginTop: "24px",
						justifyContent: "space-around",
					}}
				>
					{buttonsSettings.map((btn) => (
						<LoadingButton
							key={btn.title}
							variant="contained"
							loading={btn.loading}
							disabled={btn.disabled}
							className={clsx({
								"!rounded-md !text-sm !text-nowrap !capitalize !font-sans": true,
							})}
							sx={{
								maxWidth: "max-content",
								bgcolor: btn.bgColor,
								boxShadow: "none",
								"&:hover": {
									bgcolor: btn.bgColor,
									boxShadow: btn.boxShadowHover ?? "none",
								},
								"&:disabled": {
									bgcolor: "var(--disabled-and-stroke-color)",
								},
								"& .MuiLoadingButton-loadingIndicator": {
									color: "white",
								},
								color: btn.loading ? btn.bgColor : "white",
								padding: "5px 20px",
							}}
							onClick={() => {
								btn.action();
							}}
						>
							{btn.title}
						</LoadingButton>
					))}
				</DialogActions>
			</Stack>
		</Dialog>
	);
};

export default ActionButtonDialog;
